import { render, staticRenderFns } from "./ArchiveChatComments.vue?vue&type=template&id=056a6625&"
import script from "./ArchiveChatComments.vue?vue&type=script&lang=ts&"
export * from "./ArchiveChatComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports